import { useEffect, useRef } from 'react'

import { useLocation } from 'Pods/Shared/ContextBasedRouter'
import { threeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { closeFullImageEditor } from 'Pods/ThreeDStudio/Store/actions/ui'

// The library sidebar is the only way out of the full-width image editor, and its nav
// items are SPA route changes rather than reloads. openedImage would otherwise survive
// the pathname change and render the editor on top of whatever page the user landed on.
export default function useCloseImageEditorOnNavigate() {
  const location = useLocation()
  const pathname = location?.pathname ?? ''
  const previousPathnameRef = useRef(pathname)

  useEffect(() => {
    if (previousPathnameRef.current === pathname) {
      return
    }
    previousPathnameRef.current = pathname

    if (threeDStudioStore.getState().ui.openedImage) {
      closeFullImageEditor()
    }
  }, [pathname])
}
